import moment from 'moment-timezone';

// hard-coded minimum year, to ensure valid Unix timestamp is obtained
// minimum valid timestamp in CIO code validations (both BE and FE) is 99999999: 1973.03.
// round this up to next calendar year for simplicity
const MIN_SELECTABLE_YEAR = 1974;
const generateYears = () => {
  let currentYear = moment().year();

  // generate years starting from minimum to 2 years in the future
  // (using "3" due to 0-indexed arrays)
  let yearsToGenerate = currentYear - MIN_SELECTABLE_YEAR + 3;
  return [...new Array(yearsToGenerate).keys()].map(i => i + MIN_SELECTABLE_YEAR);
};
export const MONTHS = moment.localeData('en').months();
export const YEARS = generateYears();
export const DEFAULT_FORMAT = 'MMM DD, YYYY';
export const ALL_TIME_RANGE = null;
export const CUSTOM_RANGE = 'custom';
const getRangeFn = days => {
  return () => {
    let end = moment().startOf('day');
    let start = end.clone().subtract(days, 'days');
    return {
      start,
      end
    };
  };
};
export const LAST_24_HOURS_RANGE_PRESET = Object.freeze({
  label: 'Last 24 hours',
  value: 1,
  getRange: getRangeFn(1)
});

// We use 6 days in getRangeFn instead of 7, because subtracting 7 days from
// today would give us a range of 8 days total (including today), so we need to
// subtract 7 to get a 7-day range.
export const LAST_7_DAYS_RANGE_PRESET = Object.freeze({
  label: 'Last 7 days',
  value: 7,
  getRange: getRangeFn(6)
});
export const LAST_30_DAYS_RANGE_PRESET = Object.freeze({
  label: 'Last 30 days',
  value: 30,
  getRange: getRangeFn(29)
});
export const LAST_90_DAYS_RANGE_PRESET = Object.freeze({
  label: 'Last 90 days',
  value: 90,
  getRange: getRangeFn(89)
});
export const DEFAULT_RANGE_PICKER_PRESETS = [{
  label: 'All time',
  value: ALL_TIME_RANGE,
  getRange() {
    return ALL_TIME_RANGE;
  }
}, {
  label: 'Custom',
  value: CUSTOM_RANGE,
  getRange() {
    return null;
  }
}, LAST_24_HOURS_RANGE_PRESET, LAST_7_DAYS_RANGE_PRESET, LAST_30_DAYS_RANGE_PRESET, LAST_90_DAYS_RANGE_PRESET];